import React, { useEffect, useState } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import { Paper, TableRow, Button } from '@material-ui/core';
import { IonRow, IonCol } from '@ionic/react';
import { PLStatement, PLRecordMktLvl } from '../../models/PLStatement';
import './ProfitLossStatement.scss';
import moment, { Moment } from 'moment';
import { AuthResponse } from '../../models/api/AuthResponse';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import { getCurrencyTypeFromToken } from '../../store';
import REPORTING_API from '../../reporting-api';
import { connect } from 'react-redux';
import { RootState } from '../../models/RootState';

type PLProps = {
  searchName: string;
  selectedMarket: PLStatement;
  startDate: Moment;
  endDate: Moment;
  showGameLevel: () => void;
  langData:any;
};

const PLStatementMktLvl: React.FC<PLProps> = (props) => {
  const { selectedMarket, startDate, endDate, showGameLevel, searchName,langData } =
    props;
  const [items, setItems] = useState<PLRecordMktLvl[]>();

  const [backTotal, setBackTotal] = useState<number>(0);
  const [layTotal, setLayTotal] = useState<number>(0);
  const [marketTotal, setMarketTotal] = useState<number>(0);
  const [netMarket, setNetMarket] = useState<number>(0);
  const [pageToken, setPageToken] = useState<string[]>(['']);
  const [nextPageToken, setNextPageToken] = useState<string>('');
  const [loading, setLoading] = useState<Boolean>(false);

  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];
  const pageSize = 25;

  const tableFields = [
    {
      key: 'betPlacedTime',
      Label: 'Placed',
      LangKey: 'placed',
      className: 'placed-cell-head',
      align: 'left',
    },
    {
      key: 'selection',
      Label: 'Selection',
      LangKey: 'selection',
      className: 'selection-cell-head',
      align: 'left',
    },
    {
      key: 'betId',
      Label: 'Bet ID',
      LangKey: 'bet_id',
      className: 'betid-cell-head',
      align: 'left',
    },
    {
      key: 'betType',
      Label: 'Type',
      LangKey: 'type',
      className: 'type-cell-head',
      align: 'left',
    },
    {
      key: 'odds',
      Label: 'Odds',
      Langkey: 'odds',
      className: 'odds-cell-head',
      align: 'left',
    },
    {
      key: 'stake',
      Label: 'Stake',
      LangKey: 'stake',
      className: 'stake-cell-head',
      align: 'left',
    },
    {
      key: 'profitLoss',
      Label: 'Profit/Loss',
      LangKey: 'profit_loss',
      className: 'ploss-cell-head',
      align: 'left',
    },
    {
      key: 'status',
      Label: 'Status',
      langKey:'status',
      className: 'status-cell-head',
      align: 'left',
    },
  ];

  const nextPage = () => {
    setLoading(true);
    if (nextPageToken) {
      setPageToken([...pageToken, nextPageToken]);
    }
    setLoading(false);
  };

  const prevPage = () => {
    setLoading(true);
    if (pageToken.length > 1) {
      let pagetokens = pageToken;
      pagetokens.pop();
      setPageToken([...pagetokens]);
    }
    setLoading(false);
  };

  const fetchPLByMarket = async () => {
    try {
      const response: AuthResponse = await REPORTING_API.get(
        'reports/v2/orders/:search',
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
            Accept: 'application/json',
          },
          params: {
            reportType: 'PL_REPORT',
            eventId: selectedMarket.eventId,
            categoryType: selectedMarket.categoryType,
            marketId:
              selectedMarket.categoryType !== 'CASINO'
                ? selectedMarket.marketId
                : null,
            startDate:
              selectedMarket.categoryType === 'CASINO'
                ? moment(selectedMarket.betPlacedTime)
                  .startOf('day')
                  .toISOString()
                : startDate.startOf('day').toISOString(),
            endDate:
              selectedMarket.categoryType === 'CASINO'
                ? moment(selectedMarket.betPlacedTime)
                  .endOf('day')
                  .toISOString()
                : endDate.endOf('day').toISOString(),
            pageSize: pageSize,
            pageToken: pageToken[pageToken.length - 1],
          },
        }
      );
      if (response.status === 200) {
        if (response.data?.orders) {
          let records: PLRecordMktLvl[] = response.data?.orders;
          setItems(records);
          let backCount = 0;
          let layCount = 0;
          let marketAmt = 0;
          for (let record of records) {
            if (record.betType === 'BACK') {
              backCount += record.payOutAmount;
            } else {
              layCount += record.payOutAmount;
            }
            marketAmt += record.payOutAmount;
          }
          setBackTotal(backCount / cFactor);
          setLayTotal(layCount / cFactor);
          setMarketTotal(marketAmt / cFactor);
          setNetMarket(
            marketAmt / cFactor +
            (selectedMarket.commission ? selectedMarket.commission : 0)
          );
        }
        setNextPageToken(response.data?.pageToken);
      } else {
        throw new Error(response.data);
      }
    } catch (err) {
      if (err.response && err.response.data) {
        console.error(err.response.data.error);
      }
    }
  };

  React.useEffect(() => {
    fetchPLByMarket();
  }, [pageToken]);

  return (
    <div className="modal-pl">
      {selectedMarket ? (
        <>
          <div className="pl-stmt-tbl web-view">
            <TableContainer component={Paper}>
              <Table className="myb-table">
                <TableHead className="myb-table-header sub-table-header">
                  <TableRow>
                    {tableFields.map((tF, index) => (
                      <TableCell
                        key={'key_' + Math.random().toString(36).substr(2, 9)}
                        align={tF.align === 'left' ? 'left' : 'center'}
                        className={tF.className}
                      >
                        {langData?.[tF.LangKey]}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                {items && items.length > 0 ? (
                  <>
                    <TableBody className="tbl-body">
                      {items.map((row) => (
                        <>
                          <TableRow
                            className={
                              row.payOutAmount > 0
                                ? 'profit-bg'
                                : row.payOutAmount <= 0
                                  ? 'loss-bg'
                                  : 'row-bg'
                            }
                            key={
                              'key_' + Math.random().toString(36).substr(2, 9)
                            }
                          >
                            <TableCell align="left">
                              <span className="txt-bldin-mob">
                                {moment(row.betPlacedTime).format(
                                  'D/M/YYYY HH:mm:ss'
                                )}
                              </span>
                            </TableCell>
                            <TableCell
                              className="myb-table-cell bwon-col"
                              align="left"
                            >
                              <span className="txt-bldin-mob">
                                {row.marketType === 'FANCY'
                                  ? row.marketName +
                                  ' @ ' +
                                  Number(row.oddValue * 100 - 100).toFixed(0)
                                  : row.marketType === 'BINARY'
                                    ? row.outcomeDesc + ' @ ' + Number(row.sessionRuns).toFixed(0)
                                    : row.outcomeDesc}
                              </span>
                            </TableCell>
                            <TableCell
                              className="myb-table-cell blost-col"
                              align="left"
                            >
                              <span className="txt-bldin-mob">{row.id}</span>
                            </TableCell>
                            <TableCell
                              className="myb-table-cell blost-col"
                              align="left"
                            >
                              <span className="txt-bldin-mob">
                                {row.betType == 'BACK' ? 'Back' : 'Lay'}
                              </span>
                            </TableCell>
                            <TableCell
                              className="myb-table-cell blost-col"
                              align="left"
                            >
                              <span className="txt-bldin-mob">
                                {row.oddValue === -1
                                  ? '-'
                                  : row.oddValue.toFixed(2)}
                              </span>
                            </TableCell>
                            <TableCell
                              className="myb-table-cell blost-col"
                              align="left"
                            >
                              <span className="txt-bldin-mob">
                                {(row.stakeAmount / cFactor).toFixed(2)}
                              </span>
                            </TableCell>
                            <TableCell align="left" className="pandl-col">
                              <span className="txt-bldin-mob">
                                <div
                                  className={
                                    row.outcomeResult == 'Won'
                                      ? 'profit'
                                      : 'loss'
                                  }
                                >
                                  {Number(row.payOutAmount / cFactor).toFixed(
                                    2
                                  )}
                                </div>
                              </span>
                            </TableCell>

                            <TableCell align="left" className="pandl-col">
                              <span className="txt-bldin-mob">
                                <div
                                  className={
                                    row.outcomeResult == 'Won' ||
                                      row.payOutAmount > 0
                                      ? 'profit'
                                      : 'Loss'
                                  }
                                >
                                  {row.outcomeResult == 'Won' ||
                                    row.payOutAmount > 0
                                    ? 'Win'
                                    : 'Loss'}
                                </div>
                              </span>
                            </TableCell>
                          </TableRow>
                        </>
                      ))}
                    </TableBody>
                  </>
                ) : (
                  <TableBody>
                    <TableRow>
                      <TableCell
                        className="no-data-cell"
                        variant="body"
                        colSpan={8}
                      >
                        {langData?.['no_records_found']}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </div>
          {items && items.length > 0 ? (
            <div className="mob-view mob-ctn-pl">
              <div className="pl-mob-div pl-mob-div-ctn">
                <div
                  className="heading"
                  onClick={() => {
                    showGameLevel();
                  }}
                >
                  <div className="date">
                    {/* <ArrowBackIcon
                      className="back"
                      onClick={() => {
                        showGameLevel();
                      }}
                    /> */}
                    {`${selectedMarket.eventName}-${selectedMarket.marketName}`}
                  </div>
                </div>
                {items.map((row) => (
                  <div
                    className={`pl-content ${row.betType === 'BACK' ? 'back-odd-row' : 'lay-odd-row'
                      }`}
                  >
                    <IonRow>
                      <IonCol sizeXs="7" sizeSm="7" className="market-info">
                        <div>
                          <span
                            className={`label ${row.betType == 'BACK'
                              ? 'back-bet-font'
                              : 'lay-bet-font'
                              }`}
                          >
                            {langData?.['selection']}:{' '}
                          </span>
                          <span
                            className={`value ${row.betType == 'BACK'
                              ? 'back-bet-font'
                              : 'lay-bet-font'
                              }`}
                          >
                            {row.outcomeDesc}
                          </span>
                        </div>
                        <div>
                          <span className="label">{langData?.['bet_id']}: </span>
                          <span className="value">{row.id}</span>
                        </div>
                        <div>
                          <span className="label">{langData?.['placed']}: </span>
                          <span className="value">
                            {moment(row.betPlacedTime).format(
                              'D/M/YYYY HH:mm:ss'
                            )}
                          </span>
                        </div>
                      </IonCol>
                      <IonCol sizeXs="5" sizeSm="5" className="market-info">
                        <div className="flex-row">
                          <span className="label">{langData?.['status']}: </span>
                          <span className={`value ml-auto`}>
                            <div
                              className={
                                row.outcomeResult == 'Won' ? 'profit' : 'loss'
                              }
                            >
                              {row.outcomeResult == 'Won' ? 'Win' : 'Loss'}
                            </div>
                          </span>
                        </div>
                        <div className="flex-row">
                          <span className="label">{langData?.['profit_loss']}: </span>
                          <span className={`value ml-auto`}>
                            <div
                              className={
                                row.outcomeResult == 'Won' ? 'profit' : 'loss'
                              }
                            >
                              {Number(row.payOutAmount / cFactor).toFixed(2)}
                            </div>
                          </span>
                        </div>
                      </IonCol>
                    </IonRow>
                    <IonRow>
                      <IonCol className="bet-info">
                        <div className="label">{langData?.['type']}</div>
                        <div className="value">
                          {row?.betType == 'BACK' ? 'Back' : 'Lay'}
                        </div>
                      </IonCol>
                      <IonCol className="bet-info">
                        <div className="label">{langData?.['odds']}</div>
                        <div className="value">{row?.oddValue}</div>
                      </IonCol>
                      <IonCol className="bet-info">
                        <div className="label">{langData?.['stake']}</div>
                        <div className="value">
                          {row?.stakeAmount / cFactor}
                        </div>
                      </IonCol>
                    </IonRow>
                  </div>
                ))}
              </div>
            </div>
          ) : null}
          <div className="pl-summary-mob">
            <IonRow>
            {langData?.['back_subtotal']}:{' '}
              <span className="ml-auto">{Number(backTotal).toFixed(2)}</span>
            </IonRow>
            <IonRow>
            {langData?.['lay_subtotal']}:{' '}
              <span className="ml-auto">{Number(layTotal).toFixed(2)}</span>
            </IonRow>
            <IonRow>
            {langData?.['market_subtotal']}:{' '}
              <span className="ml-auto">{Number(marketTotal).toFixed(2)}</span>
            </IonRow>
            <IonRow className="border-bottom">
            {langData?.['commission']}:{' '}
              <span className="ml-auto">
                {Number(selectedMarket.commission ?? 0).toFixed(2)}
              </span>
            </IonRow>
            <IonRow className="border-bottom net-market">
              <div className="b-text">{langData?.['net_market_total']}:</div>
              <span className="ml-auto">
                {Number(netMarket ?? 0).toFixed(2)}
              </span>
            </IonRow>
          </div>
          <div className="mob-view-pgnation">
            {pageToken.length === 1 || loading ? null : (
              <Button
                onClick={(e) => prevPage()}
                disabled={pageToken.length < 2}
                className="prev-btn"
              >
                {langData?.['prev']}({pageToken.length - 1})
              </Button>
            )}
            {nextPageToken && !loading ? (
              <Button
                onClick={(e) => nextPage()}
                disabled={!nextPageToken}
                className="next-btn"
              >
                {langData?.['next']}({pageToken.length + 1})
              </Button>
            ) : null}
          </div>
        </>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    langData:state.common.langData
  };
};

export default connect(
  mapStateToProps,
)(PLStatementMktLvl)